import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './answer.types';

export const answerSelectors = {
  ...generateResourceSelectors<types.IAnswer>((state) => state.resource.answer),
};
